import { render, staticRenderFns } from "./wygl.vue?vue&type=template&id=44f8ed4f&scoped=true&"
import script from "./wygl.vue?vue&type=script&lang=js&"
export * from "./wygl.vue?vue&type=script&lang=js&"
import style0 from "./wygl.vue?vue&type=style&index=0&id=44f8ed4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f8ed4f",
  null
  
)

export default component.exports